import clsx from 'clsx';
import { selectApp } from 'store/app/slice';
import { useTypedSelector } from 'hooks/useStore';
import Button from 'ui/Button/Button';
import './Header.scss';

const Header: React.FC = () => {
  const { isIntro } = useTypedSelector(selectApp);
  return (
    <header className={clsx('header', { animation: !isIntro })}>
      <div className="container header__container">
        <div className="header__logo">
          <img src={require('images/logo.png')} alt="logo" />
        </div>
        <Button title="Sign Up" to="/" className="header__btn" />
        <button className="header__burgermenu">
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};

export default Header;
